function getApiURL() {
  return getEnvironmentVariable(process.env.NEXT_PUBLIC_WORDPRESS_API_ENDPOINT);
}

function getCanonicalURL() {
  return getEnvironmentVariable(process.env.NEXT_PUBLIC_CANNONICAL_URL);
}

function getMatomoURL() {
  return (
    getEnvironmentVariable(process.env.NEXT_PUBLIC_MATOMO_URL) ||
    'https://report2023-cern.matomo.cloud/'
  );
}

function getMatmoSiteId() {
  return getEnvironmentVariable(process.env.NEXT_PUBLIC_MATOMO_SITE_ID) || '3';
}

function getEnvironmentVariable(value: string | undefined): string {
  if (!value) {
    throw new Error(
      'Environment variable is not set. Check environment configuration file',
    );
  }
  return value;
}

export const EnvironmentService = {
  getApiURL,
  getCanonicalURL,
  getMatomoURL,
  getMatmoSiteId,
};
